// extracted by mini-css-extract-plugin
export var chip = "_66-9";
export var chipLabel = "_66-a";
export var close = "_66-7";
export var closeIcon = "_66-8";
export var error = "_66-6";
export var infoTooltip = "_66-2";
export var innerContainer = "_66-1";
export var input = "_66-b";
export var medium = "_66-5";
export var outerContainer = "_66-0";
export var small = "_66-4";
export var xSmall = "_66-3";